export const PartnerTierTypes = Object.freeze({
  SILVER: 'silver',
  GOLD: 'gold',
  PLATINUM: 'platinum'
});